module.exports = __webpack_public_path__ + "static/media/screened_pro.27202fed.svg";